import ServiceIntervalsModal from 'components/ServiceIntervalsModal';
import PillButton from 'components/buttons/PillButton';
import PillButtonText from 'components/text/PillButtonText';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ServiceIntervalsButton: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => {
    const { CONFIGURE_INTERVALS } = useTranslation();

    const {
        assetModels,
        isEditable,
        isLoading,
        isOpen,
        isSaving,
        onClose,
        onOpen,
        onSubmit,
        partsByAssetModelId,
        unavailableAssetModelIds
    } = useData();

    return (
        <>
            <PillButton
                className={`${className} ${styles.serviceIntervalsButton}`}
                onClick={onOpen}
                testId={testId}>
                <PillButtonText text={CONFIGURE_INTERVALS} />
            </PillButton>

            {isOpen && (
                <ServiceIntervalsModal
                    assetModels={assetModels}
                    isEditable={isEditable}
                    isLoading={isLoading}
                    isSaving={isSaving}
                    onClose={onClose}
                    onSubmit={onSubmit}
                    partsByAssetModelId={partsByAssetModelId}
                    unavailableAssetModelIds={unavailableAssetModelIds}
                />
            )}
        </>
    );
};

export default ServiceIntervalsButton;
